import { GeneratedEndpointError, GeneratedErrorCode } from '@repo/backend-api-spec';

export type ErrorCode = (typeof GeneratedErrorCode)[keyof typeof GeneratedErrorCode];

export class EndpointError<T extends ErrorCode = 'UNKNOWN'> implements GeneratedEndpointError {
  code: T;
  timestamp: number;
  status: number;
  path: string;
  message: string;

  constructor(data: GeneratedEndpointError) {
    this.code = data.code as T;
    this.timestamp = data.timestamp;
    this.status = data.status;
    this.path = data.path;
    this.message = data.message;
  }
}
